import {Component, OnInit} from '@angular/core';
import {User} from '../../../../model/domain/user';
import {UserViewService} from '../user.view.service';
import {UserService} from '../../../../core/service/user.service';
import {FloorManagerMonthlyUserReport} from '../../../../model/report/floormanager/floor-manager-monthly-user-report';
import * as moment from 'moment';

@Component({
	selector: 'app-user-sales',
	templateUrl: './user-sales.component.html',
	styleUrls: ['./user-sales.component.scss']
})
export class UserSalesComponent implements OnInit {
	user: User;
	report: FloorManagerMonthlyUserReport;
	months: string[] = [];
	years: string[] = [];
	selectedMonth = moment().format('MMMM');
	selectedYear = moment().format('YYYY');

	constructor(
		private userViewService: UserViewService,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.userViewService.get().subscribe(user => {
			if (!user) {
				return;
			}

			this.user = user;
			this.loadReport(this.getSelectedMoment());
		});
	}

	updateReport(): void {
		if (!this.user) {
			return;
		}
		this.loadReport(this.getSelectedMoment());
	}

	getSelectedMoment(): moment.Moment {
		return moment()
			.set('year', Number(this.selectedYear))
			.set('month', moment().month(this.selectedMonth).month())
			.startOf('month');
	}

	private loadReport(date: moment.Moment): void {
		this.userService.getFloorManagerMonthReport(this.user.id, date.valueOf()).subscribe(result => {
			this.report = result;
			this.updateDateSelectors();
		});
	}

	private updateDateSelectors(): void {
		const firstAvailableDate = this.report && this.report.firstAvailableDate ?
			moment(this.report.firstAvailableDate).startOf('month') :
			moment().startOf('month');
		const now = moment().startOf('month');

		this.years = [];
		this.months = [];

		const years: string[] = [];
		let yearCursor = firstAvailableDate.clone().startOf('year');
		while (yearCursor.isSameOrBefore(now, 'year')) {
			years.push(yearCursor.format('YYYY'));
			yearCursor = yearCursor.add(1, 'year');
		}
		this.years = years;

		let monthCursor = moment().set('year', Number(this.selectedYear)).startOf('year');
		for (let i = 0; i < 12; i++) {
			if (monthCursor.isSameOrAfter(firstAvailableDate) && monthCursor.isSameOrBefore(now, 'month')) {
				this.months.push(monthCursor.format('MMMM'));
			}
			monthCursor = monthCursor.add(1, 'month');
		}

		if (this.years.indexOf(this.selectedYear) === -1) {
			this.selectedYear = now.format('YYYY');
		}
		if (this.months.indexOf(this.selectedMonth) === -1) {
			this.selectedMonth = this.months[this.months.length - 1];
		}
	}
}
